import React from 'react';

import { Container } from './styles';

import { MenuItemProps } from './interface';

const MenuItem: React.FC<MenuItemProps> = ({ inHead, children }) => {
  return (
    <Container inHead={inHead}>
      <>{children}</>
    </Container>
  );
};

export default MenuItem;
